import ReactDOM from 'react-dom/client'

import '@/assets/styles/app.scss'

import { App } from './App'
import './core/i18n'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)

reportWebVitals()
